import { Junction } from "../junction";
import { JunctionInfo } from "../junction.info";

/**
 * Base class for any map.
 */
export class RoadMap {

    public junctions: Array<Junction> = [];

    /**
     * Convert the junctionInfos into Junction objects.
     */
    constructor() {}

    destroy() {
        document.getElementById('mapWrapper')!.innerHTML = "";
        this.junctions = [];
    }

    convertJunctionInfosToJunctionObjects(junctionInfos: Array<JunctionInfo>): void {
        junctionInfos.forEach((junctionInfo: JunctionInfo) => {
            let junctionsToConnectTo: Array<Junction> = [];

            // Get junctions to connect to.
            junctionInfo.connectedTo.forEach((junctionIDToConnectTo: number) => {
                junctionsToConnectTo.push(this.junctions[junctionIDToConnectTo]);
            });

            this.junctions.push(
              new Junction(junctionInfo.id, junctionInfo.x, junctionInfo.y, junctionsToConnectTo)
            );
            
        });
    }


    addAllTwoWayConnections(): void {
        this.junctions.forEach(junction => {
            junction.connectedTo.forEach((junctionConnectedTo: Junction) => {
                this.junctions[junctionConnectedTo.id].connectedTo.push(junction);
            });
        });
    }


    getRandomJunction(): Junction {
        return this.junctions[Math.floor(Math.random() * this.junctions.length)];
    }


}